"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_state_tree_1 = require("mobx-state-tree");
const mst_1 = require("../../util/types/mst");
const BaseViewModel = mobx_state_tree_1.types
    .model('BaseView', {
    id: mst_1.ElementId,
    displayName: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
})
    .volatile(( /* self */) => ({
    width: 800,
}))
    .views(( /* self */) => ({
    menuItems() {
        return [];
    },
}))
    .actions(self => ({
    setDisplayName(name) {
        self.displayName = name;
    },
    setWidth(newWidth) {
        self.width = newWidth;
    },
}));
exports.default = BaseViewModel;
